import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { amber, green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles(theme => ({
  success: {
    color: green[600],
  },
  error: {
    color: theme.palette.error.dark,
  },
  info: {
    color: theme.palette.primary.main,
  },
  warning: {
    color: amber[700],
  },
  icon: {
    fontSize: 60,
    marginBottom: theme.spacing(1),
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(3),
    minHeight: 220,
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  message: {
    marginBottom: theme.spacing(2),
  },
}));

export default function FeedbackBox(props) {
  const { variant, title, message, buttonText, action } = props;
  const classes = useStyles();
  const Icon = variantIcon[variant];

  return (
    <Box className={classes.box}>
      <Icon className={clsx(classes.icon, classes.iconVariant, classes[variant])} />
      <Typography variant="h3" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body1" className={classes.message}>
        {message}
      </Typography>
      <Button variant="contained" color="primary" onClick={action}>
        {buttonText}
      </Button>
    </Box>
  );
}

FeedbackBox.defaultProps = {
  title: '',
  variant: '',
  message: '',
  buttonText: '',
  action: () => {},
};

FeedbackBox.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string,
  action: PropTypes.func,
};
